export enum Modules {
  'esite' = 'esite',
  'conteo' = 'conteo',
  'reservations' = 'reservations',
  'esitedevices' = 'esite-devices',
  'co2' = 'co2',
}
